import {CabinetMesh} from 'components/customer/RoomPlanner/types';
import {
    getPlaceholderDimensionsMm,
    PlaceholderDimensionsMm,
} from 'components/customer/RoomPlanner/helpers/placeholder/loadPlaceholderGLB';
import {findPlaceholderGroupOf} from 'components/customer/RoomPlanner/helpers/placeholder/quantity';

export type PlaceholderSelectionInfo = {
    name: string;
    dimensions: PlaceholderDimensionsMm;
    quantity: number;
};

/**
 * Name, size, and quantity for the selected appliance card.
 * Quantity is the larger of the copies in the room and the stored value.
 * @param {CabinetMesh | null | undefined} mesh Selected placeholder
 * @param {CabinetMesh[] | null | undefined} list Live placeholders
 * @return {PlaceholderSelectionInfo} Fields both info cards show
 */
export const getPlaceholderSelectionInfo = (
    mesh?: CabinetMesh | null,
    list?: CabinetMesh[] | null
): PlaceholderSelectionInfo => {
    if (!mesh) {
        return {
            name: 'Appliance',
            dimensions: {width: 0, height: 0, depth: 0},
            quantity: 1,
        };
    }

    const stored = Number(
        (mesh.userData?.values as {quantity?: number} | undefined)?.quantity
    );
    const groupSize = findPlaceholderGroupOf(list, mesh).length;

    return {
        name:
            (mesh.userData?.placeholderName as string) ||
            String(mesh.userData?.id || 'Appliance'),
        dimensions: getPlaceholderDimensionsMm(mesh),
        quantity: Math.max(groupSize, stored || 1),
    };
};
